import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import ReportBox from "../atoms/ComponentBox/ReportBox";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Bookingreports = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);
  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {hasModulePermission("Resident Account") && (
              <ReportBox
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                permissions={permissions}
                link={{ pathname: "/reports/resident-account" }}
                title="Resident Account"
              />
            )}

            {hasModulePermission("Month Wise Bill") && (
              <ReportBox
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                permissions={permissions}
                link={{ pathname: "/monthwisebill" }}
                title="Month Wise Bill"
              />
            )}

            {hasModulePermission("Outstanding Report") && (
              <ReportBox
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                permissions={permissions}
                link={{ pathname: "/outstanding" }}
                title="Outstanding Report"
              />
            )}

            {hasModulePermission("Resident Ageing") && (
              <ReportBox
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                permissions={permissions}
                link={{ pathname: "/resident-ageing" }}
                title="Resident Ageing"
              />
            )}

            {hasModulePermission("Resident Wise Details") && (
              <ReportBox
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                permissions={permissions}
                link={{ pathname: "/residentwisedtl" }}
                title="Resident Wise Details"
              />
            )}

            {hasModulePermission("Refund Register") && (
              <ReportBox
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                permissions={permissions}
                link={{ pathname: "/refund-register" }}
                title="Refund Register"
              />
            )}

            {hasModulePermission("Refund Register") && (
              <ReportBox
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                permissions={permissions}
                link={{ pathname: "/creditnote-register" }}
                title="Credit Note Register"
              />
            )}

            {hasModulePermission("Payment Request Log") && (
              <ReportBox
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                permissions={permissions}
                link={{ pathname: "/paymentreqlog" }}
                title="Payment Request Log"
              />
            )}

            {hasModulePermission("Receipt Report") && (
              <ReportBox
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                permissions={permissions}
                link={{ pathname: "/receipt-report" }}
                title="Receipt Report"
              />
            )}

             {hasModulePermission("CashFlow Report") && (
              <ReportBox
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                permissions={permissions}
                link={{ pathname: "/cashflow-report" }}
                title="CashFlow Report"
              />
            )}

            <ReportBox
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              title="General Ledger"
            />
            <ReportBox
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              title="Cash Book"
            />
            <ReportBox
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              title="Bank Book"
            />

            {hasModulePermission("Purchase Register") && (
              <ReportBox
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link="#"
                title="Purchase Register"
              />
            )}

            <ReportBox
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              title="Trial Balance"
            />
            <ReportBox
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              title="Balance Sheet"
            />
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>

          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Bookingreports;